export default __webpack_public_path__ + "static/media/foot_img_2.0deeb361.jpg";